// Accordion.jsx
import React, { useEffect, useState, useRef, forwardRef } from "react";
import "./CustomSection.css";
import TextAnimation from "./TextAnimation";
import GetAppIcon from '@mui/icons-material/GetApp';
import { IconButton } from '@mui/material';
import logo from '../karuncup.svg';
import { getLeagues } from "../services/leaguesService";
// کامپوننت لیست فایل‌ها
const FileList = ({ files }) => {
  if (!files || files.length === 0) return null;
  return (
    <ul className="mt-2 space-y-1">
      {files.map(file => (
        <li
          key={file.id}
          className="group cursor-pointer flex justify-between items-center bg-lime-500 hover:bg-slate-700 transition-colors p-2 rounded-md"
        >
          <span className="text-slate-800 group-hover:text-lime-500 break-words">{file.name}</span>
          <IconButton
            component="a"
            href={file.url}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            className="text-lime-400 group-hover:text-lime-500 group-hover:animate-pulse"
          >
            <GetAppIcon />
          </IconButton>
        </li>
      ))}
    </ul>
  );
};
// ChildAccordionItem — بدون تغییر منطقی زیاد؛ هر زیرآیتم مستقل باز/بسته می‌شود
const ChildAccordionItem = ({ child }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => setIsOpen((s) => !s);
if (child.league_type == "active") return null;
  return (
    <div key={child.id} className="flex flex-col justify-start mb-3" dir="rtl">
      <button
        onClick={toggleAccordion}
        className="w-full flex justify-between items-center py-3 text-slate-300 hover:text-slate-100 focus:outline-none"
        aria-expanded={isOpen}
        aria-controls={`accordion-content-${child.id}`}
      >
        <span className={`${isOpen ? "text-lime-300" : "text-slate-300"} transition-transform text-md md:text-xl text-right`}>
          {child.name}
        </span>
        <span className={`${isOpen ? "text-lime-300 border-lime-300" : "text-slate-300 border-white"} text-xl px-2 transition-transform  border-4 rounded-full`}>
          {isOpen ? "-" : "+"}
        </span>
      </button>

      <div
        id={`accordion-content-${child.id}`}
        className={`overflow-hidden  transition-all duration-300 ease-in-out ${isOpen ? "max-h-[500px] mt-2" : "max-h-0"}`}
      >
        <div className="text-sm text-gray-300">{child.description}</div>
      </div>
    </div>
  );
};

// AccordionItem — forwardRef تا والد بتونه بهش scroll کند
const AccordionItem = forwardRef(({ id, title, content, pic, childrenList, activeId, setActiveId,fileList,theme = { primary: "#7c3aed", accent: "#06b6d4" }  }, ref) => {
  const isOpen = activeId === "all" || activeId === id;

  const handleToggle = () => {
    if (activeId === "all") {
      // اگر دسکتاپ بود و پیش‌فرض همه باز بودند → هنگام کلیک فقط همین یکی باز بماند
      setActiveId(id);
    } else {
      // حالت موبایل یا حالت باز شدن تکی
      setActiveId(isOpen ? null : id);
    }

    if(isOpen){
      const offset = 80; // مقدار پیش‌فرض؛ در صورت نیاز آن را کاهش/افزایش کن
        const top = document.getElementById("text-leagues").getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
    }
    // وقتی کاربر روی عنوان خودش کلیک کند، هم اسکرول می‌کنیم
    if (ref && ref.current) {
      // ref ممکن است یک DOM node باشد یا شیء ref
      const el = ref.current;
      if (el && typeof el.scrollIntoView === "function") {
        // offset handling: اگر هدر ثابت داری عدد offset را طبق ارتفاع هدر تغییر بده
        const offset = 80; // مقدار پیش‌فرض؛ در صورت نیاز آن را کاهش/افزایش کن
        const top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  };
const ringGradient = `conic-gradient(from 0deg, ${theme.primary}, ${theme.accent}, #3b82f6, ${theme.primary})`;
  return (
    <div className="pt-20">
      <div ref={ref} id={`axis-${id}`} className="group relative  p-4 text-justify md:w-4/5 md:mx-auto" dir="rtl">
      <div
       
        className={`
          absolute  rounded-2xl pointer-events-none transform-gpu
          w-full h-full
          transition-opacity duration-500
          opacity-20
        `}
        style={{
          background: ringGradient,
          filter: "blur(40px)",
          zIndex: -1,
          
          
        }}
      />
      <div className="grid grid-cols-1 md:grid-cols-2  gap-4 my-4">
        <div
          className="relative scale-90 group-hover:scale-100 transition-transform duration-1000 min-h-[40vh] md:min-h-[60vh] bg-cover bg-center rounded-[20px] overflow-hidden border-l-4 border-gray-900"
          style={{ backgroundImage: `url('${pic}')` }}
        >
          <div
            className="absolute inset-0"
            style={{
              background: "radial-gradient(circle, transparent 30%, rgba(0,0,0,0.8) 100%)",
            }}
          ></div>

          <div className="absolute bottom-4 right-2 text-right p-4">
            <TextAnimation id={`text-title-${id}`} textStyle="text-2xl md:text-3xl" text={title} />
            <TextAnimation
              id={`text-content-${id}`}
              textStyle="text-sm md:text-lg mb-4"
              du={1000}
              de={500}
              text={content?.length > 100 ? content.substring(0, 100) + "..." : content}
            />
            <a
              href="./LogIn"
              className="text-black bg-lime-400 hover:bg-lime-500 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-base px-2 py-2 text-center"
            >
              ورود / ثبت نام
            </a>
          </div>
        </div>

        <div>
          {/* header / toggle */}
          <div className=" flex items-center justify-between mb-2">
            <h3 className="text-md md:text-xl font-semibold text-white hidden md:block">{title}</h3>
            <button
              onClick={handleToggle}
              className={`px-4 py-2 rounded-lg font-medium w-full md:w-fit ${isOpen ? "bg-lime-500 text-black" : "bg-slate-700 text-white"}`}
              aria-expanded={isOpen}
              aria-controls={`accordion-section-${id}`}
            >
              {isOpen ? "بستن" : "جزئیات محور"}
            </button>
          </div>
          {!isOpen ? <img src={logo} className="hidden md:block h-auto opacity-10 mx-auto" style={{marginTop:"15%", width:"40%"}} /> : ""}
          <div id={`accordion-section-${id}`} className={`transition-all duration-300 ${isOpen ? "max-h-[1300px]" : "max-h-0 overflow-hidden"}`}>
            <div className="text-sm text-gray-300 mb-4">{content}</div>
            <div>
              {childrenList && childrenList.length > 0 ? (
                childrenList.map((child) => <ChildAccordionItem key={child.id} child={child} />)
              ) : (
                <p className="text-sm text-white rounded-bl-md p-2">هیچ زیر لیگی موجود نیست.</p>
              )}
              <a
  href={`/shenasname/${id}`}
  className="text-black bg-lime-400 hover:bg-lime-500 focus:ring-4 focus:outline-none focus:ring-lime-300 font-medium rounded-lg text-base md:text-xl px-6 py-2 text-center transition-all duration-300"
>
  دیدن طرح‌ها
</a>

            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
  );
});
AccordionItem.displayName = "AccordionItem";

// Main Accordion component
const Accordion = () => {
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [activeId, setActiveId] = useState(() => {
    return window.innerWidth < 768 ? null : "all";
  });
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // refs map برای هر parentLeague
  const itemRefs = useRef({}); // itemRefs.current[id] = React.createRef() or DOM node
 useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (mobile) setActiveId(null);   // موبایل → همه بسته
      else setActiveId("all");         // دسکتاپ → همه باز
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const fetchLeagues = async () => {
      try {
        const data = await getLeagues();
        setLeagues(data);
      } catch (err) {
        console.error(err);
        setError("خطا در بارگذاری !");
      } finally {
        setLoading(false);
      }
    };

    fetchLeagues();
  }, []);

  // filter parent leagues (parent_league === null)
  const parentLeagues = leagues.filter((league) => league.parent_league === null);

  // ensure ref exists for each parent
  parentLeagues.forEach((pl) => {
    if (!itemRefs.current[pl.id]) {
      // create an object ref that holds current DOM node
      itemRefs.current[pl.id] = { current: null };
    }
  });

  // scroll to a given axis and optionally open it
  const scrollToAxis = (id) => {
    const refObj = itemRefs.current[id];
    const node = refObj ? refObj.current : null;
    if (node) {
      const offset = 80; // اگر هدر ثابت داری این مقدار را تغییر بده
      const top = node.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    } else {
      // fallback: anchor by id
      const anchor = document.getElementById(`axis-${id}`);
      if (anchor) {
        const offset = 80;
        const top = anchor.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
    // open the accordion
    setActiveId(id);
  };

  if (loading) {
    return <div className="loading text-center py-10">در حال بارگذاری...</div>;
  }

  if (error) {
    return <div className="error text-center text-red-500 py-10">{error}</div>;
  }

  return (
    <>
      <div className="spacer h-[4vh]" />
      <div className="my-4">
        <TextAnimation id="text-leagues" textStyle="text-2xl sm:text-3xl md:text-4xl" text="محورها" />
      </div>

      {/* Buttons strip: عکس + عنوان برای هر محور */}
      <div className=" my-6 mx-auto w-fit">
        <div className=" no-scrollbar py-2">
          <div className="flex gap-8 px-4 flex-wrap justify-center" dir="rtl">
           {parentLeagues.map((pl) => (
  <button
    key={`chip-${pl.id}`}
    onClick={() => scrollToAxis(pl.id)}
    className={`
      relative group min-w-[150px] max-w-[240px] flex-shrink-0 rounded-3xl p-0
      transform-gpu transition-all duration-300 will-change-transform
      hover:scale-105 active:scale-95 focus:outline-none
    `}
    style={{width:"184px"}}
    aria-label={`Scroll to ${pl.name}`}
    aria-current={activeId === pl.id ? "true" : "false"}
  >
    {/* 1) حلقه گرادیانتِ کونیک و بلور شده (دور کارت) */}
    <span
      aria-hidden
      className={`absolute -inset-1 rounded-3xl pointer-events-none
        bg-[conic-gradient(from_0deg,_#8b5cf6,_#06b6d4,_#3b82f6,_#7c3aed,_#8b5cf6)]
        blur-[10px] opacity-60
        transform-gpu
        ${activeId === pl.id ? "opacity-100" : "group-hover:opacity-100"}
        animate-[spin_7s_linear_infinite]
      `}
      style={{ WebkitMask: "linear-gradient(#000, #000)" }} // fallback (keeps element visible)
    />

   
    {/* 3) sweep نورانیِ سریع — یک نقطه/خط روشن که دور می‌چرخه */}
    <span aria-hidden className="absolute inset-0 rounded-3xl pointer-events-none">
      {/* parent برای دوران سریع */}
      
        {/* نقطهٔ روشن در بالای دایره */}
        <span
          className="absolute left-1/2 -translate-x-1/2 -top-1 w-6 h-6 rounded-full blur-[6px] opacity-90
                     bg-gradient-to-r from-white/90 via-[#a78bfa] to-[#60f0ff]"
          style={{ boxShadow: "0 0 20px #7c3aed50, 0 0 40px #06b6d450" }}
        />
      </span>
    

    {/* 4) لایهٔ محتوا (روی همه) */}
    <div className="relative z-20 rounded-2xl overflow-hidden shadow-2xl">
      {/* تصویر بالا */}
      <div
        className={`${activeId === pl.id ? "opacity-100" : "opacity-30"} h-28 md:h-36 bg-center bg-cover transform-gpu transition-transform duration-500 group-hover:-translate-y-1`}
        style={{ backgroundImage: `url('${pl.pic}')` }}
        role="img"
        aria-label={pl.name}
      />

      {/* بدنه: وسط چینِ عنوان و استایل فانتزی */}
      <div
        className={`p-4 text-center min-h-[64px] flex items-center justify-center
          ${activeId === pl.id ? "bg-gradient-to-r from-purple-600/10 via-blue-400/8 to-cyan-400/6 text-white" : "bg-slate-900/80 text-white"}
        `}
      >
        <div>
          <div className="text-sm md:text-md font-extrabold tracking-tight drop-shadow-sm">
            {pl.name}
          </div>
          {/* optional subtitle */}
          {/* <div className="text-xs text-slate-300 mt-1">زیرعنوان کوتاه</div> */}
        </div>
      </div>
    </div>
  </button>
))}

          </div>
        </div>
      </div>

      {/* Actual accordion list */}
      <div className="space-y-6">
        {parentLeagues.map((parentLeague) => {
          const children = leagues.filter(
            (league) => league.parent_league && league.parent_league.id === parentLeague.id
          );

          // create ref object if not exists
          if (!itemRefs.current[parentLeague.id]) {
            itemRefs.current[parentLeague.id] = { current: null };
          }

          // assign callback ref to get DOM node
          const setRef = (node) => {
            itemRefs.current[parentLeague.id].current = node;
          };

          return (
            <AccordionItem
              key={parentLeague.id}
              ref={setRef}
              id={parentLeague.id}
              pic={parentLeague.pic}
              content={parentLeague.description}
              activeId={activeId}
              setActiveId={setActiveId}
              title={parentLeague.name}
              childrenList={children}
              fileList={parentLeague.files}
            />
          );
        })}
      </div>
    </>
  );
};

export default Accordion;
